<template>
  <div class="Jobs">
    <div class="jobs-l">
      <template v-if="jobs.length&&!isTop">
        <div class="job" v-for="item in jobs" :key="item.id" @click="openWin(item.id)">
          <div class="job-l">
            <p class="p-title">{{item.job_name}}</p>
            <p class="p-slary">{{item.salary}}</p>
            <p class="p-adress"><i class="el-icon-location-information"></i>{{item.province+item.city+' • '+item.job_address}}</p>
          </div>
          <div class="job-r">
            <p class="p-title">{{item.enterprise_name}}</p>
            <p class="p-time">发布于：{{item.created_at}}</p>
          </div>
        </div>
      </template>
      <template v-else-if="hotJobs.length&&isTop">
        <div class="job" v-for="item in hotJobs" :key="item.id" @click="openWin(item.id)">
          <div class="job-l">
            <div id='triangle-topleft'>
              <span>热招</span>
            </div>
            <p class="p-title">{{item.job_name}}</p>
            <p class="p-slary">{{item.salary}}</p>
            <p class="p-adress"><i class="el-icon-location-information"></i>{{item.province+item.city+' • '+item.job_address}}</p>
          </div>
          <div class="job-r">
            <p class="p-title">{{item.enterprise_name}}</p>
            <p class="p-time">发布于：{{item.created_at}}</p>
          </div>
        </div>
      </template>
      <div v-else-if="!isTop" class="job" style="justify-content: center;">
        -暂无更多-
      </div>
      <el-pagination v-if="!isTop" style="margin:36px 0;" :page-size='pagesize' :current-page="page" @current-change="getJobs" background layout="prev, pager, next" :total="total">
      </el-pagination>
    </div>
    <div class="jobs-r">
      <!-- <div class="jobs-win" v-if="hotJobs.length">
        <p class="jobs-r-title">- 热招岗位 -</p>
        <div class="hot-win">
          <ul>
            <li v-for="item in hotJobs" :key="item.id">
              <div class="li-l">
                <p class="li-l-title">{{item.job_name}}</p>
                <p class="li-l-company">{{item.enterprise_name}}</p>
                <p class="li-l-address"><i class="el-icon-location-information"></i>{{item.province+item.city+'·'+item.job_address}}</p>
              </div>
              <div class="li-r">
                <p class="li-r-slary">{{item.salary.indexOf('面议')>-1?'面议':item.salary}}</p>
                <p class="li-r-time">{{item.created_at.substring(0,10)}}</p>
              </div>
            </li>
          </ul>
        </div>
      </div> -->
    </div>
    <el-dialog title="" width="888px" :visible.sync="outerVisible" center>
      <div class="dialog-div">
        <h2>{{jobObj.job_name}}</h2>
        <p class="dialog-div-salary">{{jobObj.salary}}<span class="dialog-div-time">最近活跃：{{$until.changeDate(c_date)}}</span></p>
        <div class="detail-div">
          <p class="p-flex"><span class="span-l">企业名称：</span><span class="span-r">{{jobObj.enterprise_name}}</span></p>
          <p class="p-flex"><span class="span-l">岗位类型：</span><span class="span-r">{{jobObj.job_type}}</span></p>
          <p class="p-flex"><span class="span-l">招聘人数：</span><span class="span-r">{{jobObj.recruitment}}人</span></p>
          <p class="p-flex">
            <span class="span-l">食宿安排：</span>
            <template v-for="item in foodBeds">
              <span class="span-r" v-if="item.id==jobObj.food_bed" :key="item.id">{{item.value}}</span>
            </template>
          </p>
          <p class="p-flex"><span class="span-l">年龄要求：</span><span class="span-r">{{jobObj.age_require?jobObj.age_require:'暂无'}}</span></p>
          <p class="p-flex"><span class="span-l">学历要求：</span><span class="span-r">{{jobObj.education?jobObj.education:'暂无'}}</span></p>
          <p class="p-flex"><span class="span-l">截止时间：</span><span class="span-r">{{jobObj.expect_end?jobObj.expect_end.substring(0,10):''}}</span></p>
          <p class="p-flex"><span class="span-l">联系方式：</span><span class="span-r" style="color:#4f7ba9;cursor: pointer;" @click="innerVisible = true">点击查看</span></p>
          <p class="p-flex"><span class="span-l">岗位详情：</span><span class="span-r"></span></p>
          <div class="detail-content" v-html="jobObj.job_detail">
          </div>
        </div>
        <template v-if="pics.length">
          <p class="p-flex"><span class="span-l">工作环境：</span><span class="span-r"></span></p>
          <div class="img-div">
            <el-image style="width: 100px; height: 100px;margin-right:8px;" v-for="item in  pics" :key="item" :src="item" :preview-src-list="pics"></el-image>
          </div>
        </template>
        <p class="p-flex"><span class="span-l">工作地点：</span><span class="span-r">{{jobObj.province+jobObj.city+' • '+jobObj.job_address}}</span></p>

        <!-- <p class="dialog-div-time">{{$until.changeDate(jobObj.creator_login_at.date.split('.')[0])}}</p> -->
      </div>
      <el-dialog width="555px" title="" style="text-align:center;" :visible.sync="innerVisible" append-to-body>
        <img src='../../assets/image/qxyxcx.jpg' />
        <p style="margin-top:24px;font-size:16px;padding-bottom:24px;">微信扫一扫，使用小程序投递简历</p>
      </el-dialog>
      <div slot="footer" class="dialog-footer" style="padding-bottom:24px;">
        <!-- <el-button @click="outerVisible = false">取 消</el-button> -->
        <el-button type="primary" @click="innerVisible = true" style="width:150px;" round>投递简历</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Jobs',
  data() {
    return {
      proList: [],
      activeIndex: '/',
      jobs: [],
      page: 1,
      pagesize: 10,
      total: 0,
      hotJobs: [],
      outerVisible: false,
      innerVisible: false,
      jobObj: '',
      foodBeds: [],
      pics: [],
    };
  },
  components: {},
  props: ['isTop', 'datee', 'cityId', 'slaryStart', 'slaryEnd', 'jobType', 'provinceId', 'searchVal','company'],
  created() {},
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
    // setTimeout(this.winMove, 1000);
    if (this.isTop) {
      this.getHotJobs();
    } else {
      this.getJobs(1);
    }
    this.getFoodBed();
  },
  computed: {
    isToken() {
      return this.$store.state.token;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    c_date() {
      return this.jobObj.creator_login_at ? this.jobObj.creator_login_at.date.split('.')[0] : '';
    },
  },
  methods: {
    openWin(id) {
      this.outerVisible = true;
      this.pics = [];
      this.getJobDetail(id);
      this.getJobBackground(id);
    },
    async getFoodBed() {
      let res = await this.$api.instance.getFoodBed();
      if (res.code == 0) {
        this.foodBeds = res.data;
      }
    },
    async getJobDetail(id) {
      let res = await this.$api.job.getJobDetail(id);
      if (res.code == 0) {
        this.jobObj = res.data;
      }
    },
    async getJobBackground(id) {
      let res = await this.$api.job.getJobPic(id);
      if (res.code == 0 && res.data.length) {
        this.pics = res.data.map((item) => item.sign);
      }
    },
    async getJobs(val) {
      this.page = val;
      // console.log(this.datee)
      // console.log(this.cityId)
      // console.log(this.slaryStart)
      // console.log(this.slaryEnd)
      // console.log(this.jobType)
      // console.log(this.provinceId)

      let params = {
        page: this.page,
        page_size: this.pagesize,
        create_at: this.datee,
      };
      if (this.searchVal) {
        params.job_name = this.searchVal;
      }
      if (this.cityId) {
        params.city_id = this.cityId;
      }
      if (this.provinceId) {
        params.province_id = this.provinceId;
      }
      if (this.slaryStart) {
        params.start_salary = this.slaryStart;
      }
      if (this.slaryEnd) {
        params.end_salary = this.slaryEnd;
      }
      if (this.jobType && this.jobType != '不限') {
        params.job_type = this.jobType;
      }
      if(this.company){
        params.enterprise_name = this.company
      }
      // console.log(this.isTop);
      // if (!this.isTop) {
      let res = await this.$api.job.getJobs(params);
      if (res.code == 0) {
        this.jobs = res.data.data;
        this.total = res.data.total;
      }
      scrollTo(0, 0);
      // }
    },
    async getHotJobs() {
      let res = await this.$api.job.getHotJobs();
      if (res.code == 0) {
        this.hotJobs = res.data;
      }
    },
    handLoginClick() {
      this.$router.push({
        path: '/login',
      });
    },
    handleCommand(com) {
      if (com == 'logOut') {
        this.handleBack();
      }
    },
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
      this.activeIndex = key;
    },
    handleBack() {
      this.$store.commit('setUserInfo', null);
      this.$store.commit('setToken', null);
    },
  },
};
</script>
<style lang="less" scoped>
#triangle-topleft {
  width: 0;
  height: 0;
  border-top: 42px solid #da5050;
  border-right: 72px solid transparent;
  position: absolute;
  left: -38px;
  top: -14px;
  span {
    color: #fff;
    position: absolute;
    top: -40px;
    left: 2px;
    font-weight: bold;
    font-style: italic;
    font-size: 14px;
    width: 50px;
    font-size: 13px;
    transform: rotate(-32deg);
    -ms-transform: rotate(-32deg); /* IE 9 */
    -moz-transform: rotate(-32deg); /* Firefox */
    -webkit-transform: rotate(-32deg); /* Safari 和 Chrome */
    -o-transform: rotate(-32deg); /* Opera */
    letter-spacing: 2px;
  }
}
.dialog-div {
  text-align: left;
  padding: 0 40px 0;
  .p-flex {
    display: flex;
    .span-l {
      font-weight: bold;
      width: 72px;
    }
    .span-r {
      flex: 1;
    }
  }
  .detail-div {
    margin-top: 24px;

    .detail-content {
      min-height: 100px;
      border: 1px solid #aaa;
      border-radius: 10px;
      margin-top: 16px;
      padding: 16px 24px;
    }
  }
  p {
    margin-top: 8px;
  }
  &-salary {
    margin-top: 16px;
    color: #ec6941;
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 20px;
    border-bottom: 1px solid #ccc;
  }
  &-time {
    font-size: 14px;
    color: #a0a0a0;
    font-style: italic;
    font-weight: normal;
    margin-left: 24px;
  }
}
.img-div {
  display: flex;
  padding: 16px 0;
}
.Jobs {
  // background: #b75d5d;
  width: 1200px;
  margin: 0 auto;
  // height: 120px;
  border-bottom: 1px solid #ccc;
  position: relative;
  display: flex;
  .jobs-l {
    // width: 860px;
    width: 1200px;
    .job-no {
      margin: 48px;
    }
    .job {
      display: flex;
      box-shadow: 0 0 2px 2px #ccc;
      padding: 12px 36px;
      margin-top: 16px;
      cursor: pointer;
      p {
        padding: 4px 0;
      }
      .p-title {
        color: #2f526b;
        font-size: 18px;
        font-weight: bold;
      }
      .job-l {
        text-align: left;
        position: relative;
        width: 50%;
        .p-slary {
          font-size: 16px;
          font-weight: bold;
          color: #fd5f39;
        }
        .p-adress {
          color: #4f7ba9;
          font-size: 14px;
        }
      }
      .job-r {
        width: 50%;
        text-align: right;
        .p-time {
          font-size: 14px;
          color: #9a9898;
        }
      }
    }
    .job:hover {
      box-shadow: 0 0 2px 1px #ccc;
    }
  }
  .jobs-r {
    // margin-left: 16px;
    flex: 1;
    position: relative;
    &-title {
      padding: 0px 0 16px;
      color: #e64018;
      font-weight: bold;
    }
    .jobs-win {
      z-index: 999;
      position: fixed;
      width: 300px;
      height: 450px;
      box-shadow: 0 0 2px 2px #ccc;
      padding: 24px 12px;
      background: #fff;
      margin-top: 15px;
    }
    .hot-win {
      height: calc(100% - 40px);
      ul {
        height: 100%;
        padding: 0 8px;
        overflow: auto;
      }
      li {
        display: flex;
        padding: 12px 8px;
        border-bottom: 1px dashed #2f526b;
        cursor: pointer;
        p {
          margin-top: 4px;
        }
        .li-l {
          text-align: left;
          width: 200px;
          &-title {
            color: #2f526b;
            font-size: 14px;
            font-weight: bold;
          }
          &-company {
            color: #555;
            font-weight: bold;
            font-size: 12px;
          }
          &-address {
            color: #4f7ba9;
            font-size: 12px;
          }
        }
        .li-r {
          text-align: center;
          margin-left: 6px;
          flex: 1;
          &-slary {
            font-size: 14px;
            font-weight: bold;
            color: #fd5f39;
          }
          &-time {
            color: #9a9898;
            font-size: 12px;
          }
        }
      }
      li:hover {
        border-bottom: 1px solid #2f526b;
      }
    }
  }
}
</style>
